'use client'

import { type Table } from '@tanstack/react-table'
import { Trash2 } from 'lucide-react'
import * as React from 'react'
import { useTranslation } from 'react-i18next'

import { Button } from '@/components/ui/button'
import { PostPurchaseRuleItem } from '@/lib/api/postPurchaseRules'
import { BulkDeletePostPurchaseRulesModal } from './bulk-delete-post-purchase-rules-modal'

interface PostPurchaseRulesTableActionBarProps {
	table: Table<PostPurchaseRuleItem>
	storeId: string
}

/**
 * PostPurchaseRulesTableActionBar component for bulk actions on selected rules
 */
export const PostPurchaseRulesTableActionBar = ({ table, storeId }: PostPurchaseRulesTableActionBarProps) => {
	const { t } = useTranslation('postPurchaseRules')
	const [showDeleteModal, setShowDeleteModal] = React.useState(false)
	const selectedRows = table.getFilteredSelectedRowModel().rows

	if (selectedRows.length === 0) {
		return null
	}

	const selectedCount = selectedRows.length
	const selectedRuleIds = selectedRows.map((r) => r.original.id)

	const handleDeleteSuccess = () => {
		table.resetRowSelection()
	}

	return (
		<>
			<div className="flex items-center gap-2">
				<span className="text-muted-foreground text-sm">{selectedCount} {t('actions.selected')}</span>
				<Button variant="outline" size="sm" onClick={() => setShowDeleteModal(true)} className="h-8">
					<Trash2 className="mr-2 h-4 w-4" />
					{t('actions.deleteSelected')}
				</Button>
			</div>

			{showDeleteModal && (
				<BulkDeletePostPurchaseRulesModal
					ruleIds={selectedRuleIds}
					storeId={storeId}
					onClose={() => setShowDeleteModal(false)}
					onSuccess={handleDeleteSuccess}
				/>
			)}
		</>
	)
}

